import React, { useMemo } from "react";

const countWords = (text) =>
    String(text || "")
        .trim()
        .split(/\s+/)
        .filter(Boolean).length;

export default function QuestionDissertation({ question, value, onChange, disabled }) {
    const config = question.configJson || {};
    const wordsCount = useMemo(() => countWords(value), [value]);
    const minWords = Number(config.nb_mots_min || 0);
    const maxWords = Number(config.nb_mots_max || 0);

    return (
        <div className="qr-dissertation">
            <textarea
                className="qr-textarea"
                value={value || ""}
                onChange={(event) => onChange(event.target.value)}
                disabled={disabled}
                rows={8}
                placeholder="Redigez votre reponse"
            />
            <div className="qr-word-counter">
                <span>{wordsCount} mot(s)</span>
                {minWords > 0 ? <span>Minimum recommande: {minWords}</span> : null}
                {maxWords > 0 ? <span>Maximum recommande: {maxWords}</span> : null}
            </div>
        </div>
    );
}
